export const reportsRoute: string = "reports";

export * from "./financial-report/reports.component";
export { ReportingModule } from "./reporting.module"